module.exports = __webpack_public_path__ + "static/media/mastercard.fd1e0e6e.svg";